<template>
  <header class="site-header">
    <div class="site-header__inner shell">
      <router-link class="brand" to="/">
        <span class="brand__badge">
          <img
            class="brand__logo"
            src="https://file.qzgjwh.com/0.picture/logo1.png"
            decoding="async"
            alt="青追国际教育"
          />
        </span>
        <div class="brand__text">
          <span class="brand__name">青追国际教育</span>
          <span class="brand__tagline">家校社协同成长平台</span>
        </div>
      </router-link>

      <nav class="main-nav">
        <div
          v-for="item in navItems"
          :key="item.label"
          class="nav-group"
          :class="{ 'nav-group--active': isActive(item.path) }"
        >
          <router-link class="nav-group__link" :to="item.path">
            {{ item.label }}
          </router-link>
          <div v-if="item.children" class="nav-group__panel">
            <button
              v-for="child in item.children"
              :key="child.label"
              class="nav-group__action"
              type="button"
              @click="goAnchor(item.path, child.anchor)"
            >
              <span>{{ child.label }}</span>
              <small>{{ child.en }}</small>
            </button>
          </div>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "QingHeader",
  data() {
    return {
      navItems: [
        {
          label: "首页",
          path: "/",
          children: [
            { label: "公司简介", en: "About", anchor: "#company" },
            { label: "使命与追求", en: "Mission", anchor: "#mission" },
            { label: "我们的优势", en: "Advantage", anchor: "#advantage" },
            { label: "成长案例", en: "Cases", anchor: "#case" },
            { label: "办公地点", en: "Address", anchor: "#address" },
          ],
        },
        {
          label: "业务",
          path: "/business",
          children: [
            { label: "核心产品", en: "Core", anchor: "#business-hexin" },
            { label: "父母升维", en: "Parents", anchor: "#business-sw" },
            { label: "线下陪伴", en: "Offline", anchor: "#business-pb" },
            { label: "孩子圈层", en: "Circle", anchor: "#business-qc" },
            { label: "线上陪伴", en: "Online", anchor: "#business-qzpb" },
          ],
        },
        {
          label: "精选",
          path: "/article",
          children: [
            { label: "精选文章", en: "Stories", anchor: "#job-rcln" },
            { label: "更多关注", en: "Insight", anchor: "#article-focus" },
          ],
        },
        {
          label: "团队",
          path: "/team",
          children: [
            { label: "创始人", en: "Founder", anchor: "#team-csr" },
            { label: "专家团", en: "Experts", anchor: "#team-zjt" },
            { label: "导师团", en: "Mentors", anchor: "#team-ppt" },
            { label: "名师团", en: "Teachers", anchor: "#team-dst" },
          ],
        },
        {
          label: "人才",
          path: "/job",
          children: [
            { label: "人才理念", en: "Philosophy", anchor: "#job-rcln" },
            { label: "招贤纳士", en: "Join Us", anchor: "#job-zxns" },
          ],
        },
        {
          label: "我们",
          path: "/we",
          children: [
            { label: "员工发展", en: "Growth", anchor: "#we-ygfz" },
            { label: "联系我们", en: "Contact", anchor: "#we-lxwm" },
          ],
        },
      ],
    };
  },
  methods: {
    isActive(path) {
      if (path === "/") {
        return this.$route.path === "/" || this.$route.path === "/home";
      }
      return this.$route.path.startsWith(path);
    },
    async goAnchor(toPath, id) {
      if (this.$route.path !== toPath) {
        await this.$router.push(toPath);
      }
      this.$nextTick(() => {
        const anchor = document.querySelector(id);
        if (!anchor) {
          return;
        }
        const top =
          anchor.getBoundingClientRect().top + window.pageYOffset - 116;
        window.scrollTo({
          top,
          behavior: "smooth",
        });
      });
    },
  },
};
</script>

<style scoped lang="less">
.site-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1200;
  width: 100%;
  padding: 0;
}

.site-header__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  max-height: 100px;
  width: 100%;
  max-width: none;
  padding: 8px 32px;
  border-radius: 0;
  background: linear-gradient(
    180deg,
    rgba(245, 250, 255, 0.98),
    rgba(235, 244, 253, 0.96)
  );
  border-bottom: 1px solid rgba(77, 116, 218, 0.12);
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 24px rgba(68, 98, 155, 0.08);
}

.brand {
  display: flex;
  align-items: center;
  gap: 16px;
  text-decoration: none;
  color: var(--ink);

  &__badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 0;
    height: auto;
    padding: 0;
    border: 0;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
    line-height: 0;
  }

  &__logo {
    display: block;
    width: auto;
    height: 120px;
    max-width: none;
    object-fit: contain;
  }

  &__text {
    display: flex;
    flex-direction: column;
    gap: 4px;
    text-align: left;
  }

  &__name {
    font-family: "STSong", "Songti SC", "Noto Serif SC", serif;
    font-size: 24px;
    font-weight: 700;
    letter-spacing: 0.04em;
  }

  &__tagline {
    color: var(--ink-soft);
    font-size: 12px;
    letter-spacing: 0.16em;
    text-transform: uppercase;
  }
}

.main-nav {
  display: flex;
  align-items: stretch;
  gap: 8px;
}

.nav-group {
  position: relative;
  padding-bottom: 14px;
  margin-bottom: -14px;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    height: 16px;
  }

  &__link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 76px;
    height: 58px;
    padding: 0 16px;
    border-radius: 16px;
    color: var(--ink);
    font-size: 15px;
    font-weight: 600;
    transition: transform 0.2s ease, background-color 0.2s ease, color 0.2s ease;
  }

  &__panel {
    position: absolute;
    top: calc(100% + 4px);
    left: 50%;
    display: grid;
    gap: 10px;
    min-width: 214px;
    padding: 16px;
    border-radius: 22px;
    background: rgba(255, 255, 255, 0.96);
    border: 1px solid rgba(255, 255, 255, 0.76);
    box-shadow: 0 20px 55px rgba(62, 95, 148, 0.16);
    opacity: 0;
    pointer-events: none;
    transform: translateX(-50%) translateY(8px);
    transition: opacity 0.24s ease, transform 0.24s ease;
    backdrop-filter: blur(16px);
  }

  &__action {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 3px;
    width: 100%;
    padding: 12px 14px;
    border: 0;
    border-radius: 16px;
    background: transparent;
    color: var(--ink);
    font: inherit;
    text-align: left;
    transition: background-color 0.2s ease, transform 0.2s ease;
    cursor: pointer;

    small {
      color: var(--ink-soft);
      font-size: 11px;
      letter-spacing: 0.12em;
      text-transform: uppercase;
    }
  }

  &:hover &__panel {
    opacity: 1;
    pointer-events: auto;
    transform: translateX(-50%) translateY(0);
  }

  &:hover &__link,
  &--active &__link {
    background: rgba(77, 116, 218, 0.1);
    color: var(--jade);
    transform: translateY(-1px);
  }

  &__action:hover {
    background: rgba(77, 116, 218, 0.08);
    transform: translateX(2px);
  }
}

@media (max-width: 1100px) {
  .site-header {
    padding-top: 0;
  }

  .site-header__inner {
    flex-direction: column;
    align-items: flex-start;
    padding: 18px 20px;
  }

  .brand__logo {
    height: 92px;
    max-width: none;
  }

  .main-nav {
    flex-wrap: wrap;
    width: 100%;
  }

  .nav-group__panel {
    left: 0;
    transform: translateX(0) translateY(8px);
  }

  .nav-group:hover .nav-group__panel {
    transform: translateX(0) translateY(0);
  }
}

@media (max-width: 700px) {
  .brand__badge {
    min-width: 0;
    height: auto;
    padding: 0;
  }

  .brand__logo {
    height: 68px;
    width: auto;
    max-width: none;
  }

  .brand__name {
    font-size: 20px;
  }

  .main-nav {
    gap: 4px;
  }

  .nav-group__link {
    min-width: auto;
    padding: 0 12px;
    font-size: 14px;
  }
}
</style>
